export type RuleExitMode = "discard" | "leave";

/**
 * Whether leaving a rule surface needs a confirmation, and which one.
 *
 * Only unsaved work earns a prompt. A clean surface never blocks — not even a
 * rule Atlas is still building from the rail, which stays mounted across the
 * route change and loses nothing when the page behind it changes. A prompt on
 * a clean exit trains the merchant to click through it, which is the one
 * thing the dirty prompt cannot survive.
 */
export const resolveRuleExitMode = ({
  isDirty,
}: {
  isDirty: boolean;
}): RuleExitMode | null => (isDirty ? "discard" : null);

/**
 * Whether Back on a rule asks "Keep this rule?" (ENG-7894): the rule the open
 * Atlas session just created (`createdRuleId`), while nothing uses it.
 * Creating a rule saves it straight away, so backing out of the build
 * otherwise left a draft behind without a word. A rule reopened later is not
 * asked about — its draft was kept on purpose — and an unknown usage (`null`)
 * never is, since that read may still be in flight.
 */
export const offersKeepDraftOnLeave = ({
  ruleId,
  createdRuleId,
  usedIn,
}: {
  ruleId: string;
  createdRuleId: string | null;
  usedIn: readonly unknown[] | null;
}): boolean =>
  createdRuleId === ruleId && usedIn !== null && usedIn.length === 0;
